import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { useAuth } from 'src/hooks';
import { updatePrefferedResponses } from 'src/utils/urls';
import { usePersonRepoStore } from '../store/personRepoStore';

import { PreferredResponses } from '../types/QuestionsTabType';

async function updatePreferredReasons({
  token,
  tokenType,
  accountId,
  requestBody,
  personId,
}: {
  token: string;
  tokenType: string;
  accountId: number;
  personId: string;
  requestBody: TVariables;
}): Promise<any> {
  const response = await fetch(updatePrefferedResponses(accountId, personId), {
    method: 'PUT',
    headers: {
      Authorization: `${tokenType} ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(requestBody),
  });

  if (response.status === 200) return 'Success';
  else return response.json();
}

export type TResult = string;
type TError = { message: string };

export type TVariables = PreferredResponses[];

function useUpdatePreferredResponses(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  unknown
> {
  const { token, tokenType } = useAuth();
  const accountId = usePersonRepoStore.getState().personDetails?.AccountId;
  const personId = usePersonRepoStore.getState().personDetails?.EntityId;

  const queryClient = useQueryClient();

  return useMutation(async (requestBody: TVariables) => {
    const response = await updatePreferredReasons({
      token,
      tokenType,
      accountId,
      personId,
      requestBody,
    });

    queryClient.invalidateQueries(['get-person-details'], {
      refetchActive: true,
    });
    if (response === 'Success') return response;
    else throw response;
  });
}

export { useUpdatePreferredResponses };
